import React from 'react';

export const LinkBaseUrlContext = React.createContext<string | null>(null);
